<template>
    <div v-if="loading" :class="`main-loader ${innerLoading ? 'inner-loader' : ''}`">
        <svg v-if="useAnimatedDots" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200" aria-label="Loading">
            <circle fill="currentColor" stroke="currentColor" stroke-width="15" r="15" cx="40" cy="100">
                <animate
                    attributeName="opacity"
                    calcMode="spline"
                    dur="1.2s"
                    values="1;0.2;1"
                    keySplines=".5 0 .5 1;.5 0 .5 1"
                    repeatCount="indefinite"
                    begin="0s"
                />
            </circle>
            <circle fill="currentColor" stroke="currentColor" stroke-width="15" r="15" cx="100" cy="100">
                <animate
                    attributeName="opacity"
                    calcMode="spline"
                    dur="1.2s"
                    values="1;0.2;1"
                    keySplines=".5 0 .5 1;.5 0 .5 1"
                    repeatCount="indefinite"
                    begin="0.2s"
                />
            </circle>
            <circle fill="currentColor" stroke="currentColor" stroke-width="15" r="15" cx="160" cy="100">
                <animate
                    attributeName="opacity"
                    calcMode="spline"
                    dur="1.2s"
                    values="1;0.2;1"
                    keySplines=".5 0 .5 1;.5 0 .5 1"
                    repeatCount="indefinite"
                    begin="0.4s"
                />
            </circle>
        </svg>
        <img v-else :src="dynamicAsset" alt="Loading" />
    </div>
</template>

<script>
import { computed } from 'vue';
export default {
    name: 'InnerLoader',
    props: {
        loading: {
            type: Boolean,
            default: false
        },
        innerLoading: {
            type: Boolean,
            default: false
        }
    },
    setup() {
        const ASSETS_CLIENT_NAME = process.env.VUE_APP_ASSETS_CLIENT_NAME;

        // PNG loaders can't animate individual dots; use inline SVG blink instead
        const useAnimatedDots = computed(() => {
            return ASSETS_CLIENT_NAME === 'enjojj' || ASSETS_CLIENT_NAME === 'keisi';
        });

        const dynamicAsset = computed(() => {
            if (ASSETS_CLIENT_NAME === 'enjojj' || ASSETS_CLIENT_NAME === 'keisi') {
                return require(`@/assets/media/${ASSETS_CLIENT_NAME}/${ASSETS_CLIENT_NAME}_loader.png`);
            }
            return require(`@/assets/media/${ASSETS_CLIENT_NAME}/${ASSETS_CLIENT_NAME}_loader.svg`);
        });

        return {
            ASSETS_CLIENT_NAME,
            useAnimatedDots,
            dynamicAsset
        };
    }
};
</script>

<style scoped lang="scss">
.main-loader {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: 9999;
    background: rgba(0, 0, 0, 0.7);
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;

    svg,
    img {
        display: block;
        max-width: 8rem;
        margin: 0 auto;
        height: auto;
    }

    svg {
        color: var(--bs-primary-color);
    }

    &.inner-loader {
        position: absolute;

        svg,
        img {
            max-width: 6rem;
        }
    }
}
</style>
